import type React from 'react';
import { resolveImagePath } from '@/utils/imageResolver';

interface Partner {
  name: string;
  logo: string;
  description: string;
  ctaText: string;
  ctaUrl: string;
}

const partners: Partner[] = [
  {
    name: 'Quest Cars',
    logo: '/wp-content/uploads/2024/02/quest-car-rentals-logo-2023.png',
    description: 'At Quest Car Rental, we are dedicated to providing you with a seamless and enjoyable car rental experience. Whether you\'re traveling for business, heading out on a family vacation, or need a reliable ...',
    ctaText: 'Rent A Car',
    ctaUrl: 'https://questcar.com'
  },
  {
    name: 'Jet South',
    logo: '/wp-content/uploads/2024/10/jet-south-logo.png',
    description: 'At Jet South, we understand that time is your most valuable asset, and our private aviation charter service is designed to give you more of it. As a premier private flight manager, we specialize in of...',
    ctaText: 'Book A Flight',
    ctaUrl: 'https://jetsouth.com/'
  },
  {
    name: 'Centric Aviation',
    logo: '/wp-content/uploads/2024/10/Centric-white-Background.png',
    description: 'Centric\'s strategically located FBOs offer a full range of services, including fueling, aircraft handling, hangar space, aircraft maintenance, and concierge services. With modern facilities and highly...',
    ctaText: 'Rent A Hangar',
    ctaUrl: 'https://centricaviation.com/'
  }
];

export function Partners(): React.ReactElement {
  return (
    <section className="py-16 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-12">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900">
            OUR <span className="text-blue-600">Partners</span>
          </h2>
        </div>
        
        {/* Partners Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {partners.map((partner) => (
            <div key={partner.name} className="bg-white rounded-lg shadow-lg p-6 text-center">
              {/* Logo */}
              <div className="mb-6 h-24 flex items-center justify-center">
                <img
                  src={resolveImagePath(partner.logo)}
                  alt={`${partner.name} Logo`}
                  className="max-h-full max-w-full object-contain"
                  onError={(e) => {
                    // Fallback for missing images
                    const target = e.target as HTMLImageElement;
                    target.style.display = 'none';
                  }}
                />
              </div>
              
              {/* Partner Name */}
              <h3 className="text-xl font-semibold text-gray-900 mb-4">
                {partner.name}
              </h3>
              
              {/* Description */}
              <p className="text-gray-600 text-sm mb-6 leading-relaxed">
                {partner.description}
              </p>
              
              {/* CTA Button */}
              <a
                href={partner.ctaUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-block px-6 py-3 bg-blue-600 text-white font-semibold rounded-lg hover:bg-blue-700 transition-colors duration-300"
              >
                {partner.ctaText}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}